export type BatteryModeId =
  | 'live-tracking-10s'
  | 'live-tracking-60s'
  | 'fixed-interval-1hr'
  | 'fixed-interval-6hr'
  | 'fixed-interval-12hr';

export const DEFAULT_TRACKING_MODE_ID: BatteryModeId = 'live-tracking-10s';

export interface DeviceConfigData {
  batteryMode?: BatteryModeId;
}

export interface DeviceConfig {
  data: DeviceConfigData,
  syncState: string;
}

export type BatteryModeOption = {
  id: BatteryModeId;
  label: string;
  durationDescription: string;
  description: string;
  extraInfo?: string;
};

export const BATTERY_MODE_OPTIONS: BatteryModeOption[] = [
  {
    id: 'live-tracking-10s',
    label: '10 second updates',
    durationDescription: '1 week',
    description:
      'In this mode your device remains online 24/7 and will send position updates every 10 seconds whilst moving.',
    extraInfo:
      'Ideal for tracking vehicles and other fast moving assets. Offers the most detailed location data.',
  },
  {
    id: 'live-tracking-60s',
    label: '60 second updates',
    durationDescription: '1-2 weeks',
    description:
      'In this mode your device remains online 24/7 and will send position updates every 60 seconds whilst moving.',
    extraInfo: 
      'Works well for tracking vehicles and other fast moving assets. Slightly reduced location data compared to 10s ' +
      'mode but with the benefit of extended battery life.',
  },
  {
    id: 'fixed-interval-1hr',
    label: '1 hour updates',
    durationDescription: '3 months',
    description: 
      'In this mode your device will send position updates every 1 hour. In between updates the device will enter ' + 
      'sleep mode to conserve battery life.',
    extraInfo:
      'Ideal for tracking assets that move infrequently. Offers a good balance between battery life and location ' +
      'data qualtity.',
  },
  {
    id: 'fixed-interval-6hr',
    label: '6 hour updates',
    durationDescription: '9 months',
    description:
      'In this mode your device will send position updates every 6 hours. In between updates the device will enter ' + 
      'sleep mode to conserve battery life.',
    extraInfo: 
      'Ideal for tracking assets that move very infrequently. Offers a good balance between battery life and location ' +
      'data quality.',
  },
  {
    id: 'fixed-interval-12hr',
    label: '12 hour updates',
    durationDescription: '12 months',
    description:
      'In this mode your device will send position updates every 12 hours. In between updates the device will enter ' + 
      'sleep mode to conserve battery life.',
    extraInfo:
      'Ideal for tracking assets that move very infrequently. Offers a good balance between battery life and location ' +
      'data quality.',
  },
];